import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const getSiteSettings = () => client.get("/content/site-settings").then((r) => r.data);
export const getServices = () => client.get("/content/services").then((r) => r.data);
export const getService = (slug) => client.get(`/content/services/${slug}`).then((r) => r.data);
export const getTeam = () => client.get("/content/team").then((r) => r.data);
export const getPosts = () => client.get("/content/posts").then((r) => r.data);
export const getPost = (slug) => client.get(`/content/posts/${slug}`).then((r) => r.data);
export const getLeadMagnets = () => client.get("/content/lead-magnets").then((r) => r.data);
export const submitLead = (payload) => client.post("/leads", payload).then((r) => r.data);
export const registerDownload = (slug, payload) => client.post(`/downloads/${slug}`, payload).then((r) => r.data);

export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const exchangeSession = (sessionId) =>
  client.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data);
export const logout = () => client.post("/auth/logout").then((r) => r.data);

export const adminGetDocuments = () => client.get("/admin/documents").then((r) => r.data);
export const adminUpdateDocument = (docId, payload) => client.put(`/admin/documents/${docId}`, payload).then((r) => r.data);
export const adminGetLeads = () => client.get("/admin/leads").then((r) => r.data);
export const adminUpdateLead = (leadId, status) => client.put(`/admin/leads/${leadId}`, { status }).then((r) => r.data);
export const adminGetDownloads = () => client.get("/admin/downloads").then((r) => r.data);
